import { KeyStagesSlug } from "@twinkltech/curriculum-architect-domain-hooks";

import { COMMON_NS } from "@/i18n/common/common.i18n";
import i18n from "@/i18n/i18n";

export const getCohortSlugTranslations = (cohortSlugs?: KeyStagesSlug[]) => {
  return cohortSlugs
    ? cohortSlugs.map((slug) => i18n.t(`key-stages.${slug}`, { ns: COMMON_NS }))
    : [];
};
